import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import "../global/GlobalCSS.css";
import ToolTip from "./ToolTip";
import { formattooltip } from "GenericForms/Helper";

export default function VesselDetailsHeader() {
  /** State variables start */
  const { Vessels, VesselID } = useSelector((state: any) => state.Reporting);
  const record = Vessels.find((rec: any) => rec.id === VesselID);
  const [hoverId, setHoverId] = useState<string | null>(null);
  /** State variables end */

  return (
    <Row className="justify-content-end py-1">
      <Col lg={9} className="d-flex align-items-center">
        <h2 className="page_title pos-center text-uppercase mb-0">
          {record?.vessel_name}
        </h2>
      </Col>
      <Col lg={3} className="text-end pad-right-20">
        <Row>
          <Col sm={12} className="p-0">
            <strong
              className="mb-0 card-title-desc"
              id="IMO_number"
              onMouseEnter={() => setHoverId(`IMO_number`)}
              onMouseLeave={() => setHoverId(null)}
            >
              {record?.IMO_number}
            </strong>
          </Col>
        </Row>
        <Row>
          <Col sm={12} className="p-0 text-end">
            <strong
              className="card-title-desc"
              id="Vessel_type"
              onMouseEnter={() => setHoverId(`Vessel_type`)}
              onMouseLeave={() => setHoverId(null)}
            >
              {record?.vessel_type_name}
            </strong>
          </Col>
        </Row>
      </Col>
      {hoverId !== null && document.getElementById(hoverId) !== null &&
        <ToolTip
          target={hoverId}
          message={formattooltip(hoverId)}
          isOpen={hoverId !== null}
        />
      }
    </Row>
  );
}
